import { NfzMfaFormBean } from './NfzMfaForm.types';

export const INITIAL_FORM_VALUES: NfzMfaFormBean = {
   mfaTotp: null,
};
